<template>
  <div class="company-setting">
    <v-tabs
      vertical
      active-class="custom-tab-active-item"
      v-model="settingTab"
      background-color="#fafafa"
      color="cyan darken-2"
      class="setting-vertical-tabs"
      hide-slider
    >
      <!-- Sidebar Header -->
      <div
        style="width: 270px"
        class="px-4 py-3 setting-sidebar-header d-flex align-center justify-space-between border"
      >
        <div class="d-flex align-center">
          <v-icon color="cyan darken-2" class="mr-2">mdi-cog-box</v-icon>
          <span
            class="subtitle-1 font-weight-bold grey--text text--darken-3 text-uppercase"
          >
            Settings Menu
          </span>
        </div>
        <v-chip x-small color="cyan" dark class="font-weight-bold">
          {{ SettingTabs.length }}
        </v-chip>
      </div>

      <!-- Vertical Sidebar Tabs -->
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll setting-tabs-height setting-sidebar-wrapper"
        style="height: calc(100vh - 110px); position: relative; width: 270px"
      >
        <div class="py-1">
          <template v-for="(tab, index) in SettingTabs">
            <v-tab
              v-if="getPermission(tab.permission + ':view')"
              :key="index"
              :disabled="tab.disabled"
              class="custom-setting-tab font-weight-medium px-4 py-1 justify-start text-capitalize text-left"
              :href="'#' + tab.key"
            >
              <v-icon small class="mr-3" color="cyan darken-1">{{
                getTabIcon(tab.key)
              }}</v-icon>
              <span class="text-truncate text-body-1">{{ tab.title }}</span>
            </v-tab>
          </template>
        </div>
      </perfect-scrollbar>

      <!-- Main Tab Items Content -->
      <v-tabs-items v-model="settingTab" class="px-4 pb-4 flex-grow-1">
        <template v-for="(tab, index) in SettingTabs">
          <v-tab-item
            v-if="getPermission(tab.permission + ':view')"
            :value="tab.key"
            :key="index"
          >
            <component :is="tab.template" />
          </v-tab-item>
        </template>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import EntityTemplate from "@/view/pages/profile/Setting/Entity";
import CompanyTemplate from "@/view/pages/profile/Setting/Company";
import RolePermissionTemplate from "@/view/pages/profile/Setting/RolePermission";
import BrandingTemplate from "@/view/pages/profile/Setting/Branding";
import EngineerTemplate from "@/view/pages/profile/Setting/Engineer";
import QuotationInvoiceTemplate from "@/view/pages/profile/Setting/Quotation-Invoice";
import InvoiceTemplate from "@/view/pages/profile/Setting/Invoice";
import PurchaseOrderTemplate from "@/view/pages/profile/Setting/Purchase-Order";
import ChecklistsTemplate from "@/view/pages/profile/Setting/ServiceFormTemplate";
import ClaimCategoryTemplate from "@/view/pages/profile/Setting/Claim-Category";
import CurrencyTemplate from "./Setting/CurrencyTemplate.vue";
import CalendarTemplate from "@/view/pages/profile/Setting/Calendar";
import CalendarSettingTemplate from "@/view/pages/profile/Setting/Calendar-Setting";
import EmailTemplate from "@/view/pages/profile/Setting/EmailTemplate";
import ServiceTemplate from "@/view/pages/profile/Setting/Service";
import Siklls from "@/view/pages/profile/Setting/Siklls-Cert-Lice";
import TagsList from "@/view/pages/profile/Setting/Tags-List";
import CustomerSetting from "@/view/pages/profile/Setting/Customer-Setting.vue";
import SupplierSetting from "@/view/pages/profile/Setting/Supplier-Setting.vue";
import LeaveTypeSetting from "@/view/pages/profile/Setting/LeaveType-Setting.vue";
import VisitTemplate from "@/view/pages/profile/Setting/Visit";
import ZoneTemplate from "@/view/pages/profile/Setting/ZoneTemplate";
import PropertyTemplate from "@/view/pages/profile/Setting/Property";
import OTManagementTemplate from "@/view/pages/profile/Setting/OtManagementTemplate";
import ToolTemplate from "@/view/pages/profile/Setting/Tool";

export default {
  name: "profile-setting",
  data() {
    return {
      SettingTabs: [
        {
          disabled: false,
          key: "entity",
          template: EntityTemplate,
          title: "Entity",
          permission: "setting",
        },
        {
          disabled: false,
          key: "company",
          template: CompanyTemplate,
          title: "Company",
          permission: "setting",
        },
        {
          disabled: false,
          key: "ot-management",
          template: OTManagementTemplate,
          title: "OT Management",
          permission: "setting",
        },
        {
          disabled: false,
          key: "role-permission",
          template: RolePermissionTemplate,
          title: "Role & Permission",
          permission: "setting",
        },
        {
          disabled: false,
          key: "customer-setting",
          template: CustomerSetting,
          title: "Customer",
          permission: "setting",
        },
        {
          disabled: false,
          key: "supplier-setting",
          template: SupplierSetting,
          title: "Supplier",
          permission: "setting",
        },
        {
          disabled: false,
          key: "property",
          template: PropertyTemplate,
          title: "Site Location",
          permission: "setting",
        },
        {
          disabled: false,
          key: "quotation-invoice",
          template: QuotationInvoiceTemplate,
          title: "Quotation",
          permission: "setting",
        },
        {
          disabled: false,
          key: "invoice",
          template: InvoiceTemplate,
          title: "Invoice",
          permission: "setting",
        },
        {
          disabled: false,
          key: "purchase-order",
          template: PurchaseOrderTemplate,
          title: "Purchase Order",
          permission: "setting",
        },
        {
          disabled: false,
          key: "checklists",
          template: ChecklistsTemplate,
          title: "Checklists",
          permission: "setting",
        },
        {
          disabled: false,
          key: "claim-category",
          template: ClaimCategoryTemplate,
          title: "Claim Category",
          permission: "setting",
        },
        {
          disabled: false,
          key: "currency",
          template: CurrencyTemplate,
          title: "Currency",
          permission: "setting",
        },
        {
          disabled: false,
          key: "engineer",
          template: EngineerTemplate,
          title: "Technicians",
          permission: "setting",
        },
        {
          disabled: false,
          key: "product-service",
          template: ServiceTemplate,
          title: "Products / Services",
          permission: "setting",
        },
        {
          disabled: false,
          key: "equipment",
          template: ToolTemplate,
          title: "Asset",
          permission: "setting",
        },
        {
          disabled: false,
          key: "siklls",
          template: Siklls,
          title: "Skill & Cert & Lice",
          permission: "setting",
        },
        {
          disabled: false,
          key: "zones",
          template: ZoneTemplate,
          title: "Zone Territories",
          permission: "setting",
        },
        {
          disabled: false,
          key: "visit",
          template: VisitTemplate,
          title: "Visit",
          permission: "setting",
        },
        {
          disabled: false,
          key: "branding",
          template: BrandingTemplate,
          title: "Branding",
          permission: "setting",
        },
        {
          disabled: false,
          key: "calendar",
          template: CalendarTemplate,
          title: "Holiday",
          permission: "setting",
        },
        {
          disabled: false,
          key: "calendar-setting",
          template: CalendarSettingTemplate,
          title: "Calendar Setting",
          permission: "setting",
        },
        {
          disabled: false,
          key: "leave-type-setting",
          template: LeaveTypeSetting,
          title: "Leave Type Setting",
          permission: "setting",
        },
        {
          disabled: false,
          key: "email-template",
          template: EmailTemplate,
          title: "Email Template",
          permission: "setting",
        },
        {
          disabled: false,
          key: "tag",
          template: TagsList,
          title: "Tags",
          permission: "setting",
        },
      ],
    };
  },
  watch: {
    settingTab(param) {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Profile" },
        { title: "Setting" },
        { title: this.getTitle(param) },
      ]);
    },
  },
  methods: {
    getTabIcon(key) {
      const icons = {
        entity: "mdi-domain",
        company: "mdi-office-building",
        "ot-management": "mdi-clock-outline",
        "role-permission": "mdi-shield-lock-outline",
        "customer-setting": "mdi-account-group-outline",
        "supplier-setting": "mdi-truck-outline",
        property: "mdi-map-marker-radius-outline",
        "quotation-invoice": "mdi-file-document-outline",
        invoice: "mdi-receipt",
        checklists: "mdi-checkbox-marked-outline",
        "claim-category": "mdi-cash-refund",
        currency: "mdi-currency-usd",
        engineer: "mdi-account-cog",
        "product-service": "mdi-package-variant-closed",
        equipment: "mdi-tools",
        siklls: "mdi-certificate-outline",
        zones: "mdi-map-outline",
        visit: "mdi-calendar-check-outline",
        branding: "mdi-palette-outline",
        calendar: "mdi-calendar-month-outline",
        "calendar-setting": "mdi-calendar",
        "leave-type-setting": "mdi-badge-account-outline",
        "email-template": "mdi-email-outline",
        tag: "mdi-tag-outline",
      };
      return icons[key] || "mdi-cog-outline";
    },
    getTitle(key) {
      const selected = this.lodash.find(this.SettingTabs, { key });
      if (selected) {
        return selected.title;
      }
      return "";
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Profile" },
      { title: "Setting" },
    ]);

    if (this.$route.query && this.$route.query.tab) {
      this.settingTab = this.$route.query.tab;

      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Profile" },
        { title: "Setting" },
        { title: this.getTitle(this.settingTab) },
      ]);
    }
  },
  computed: {
    settingTab: {
      set(val) {
        let query = { ...this.$route.query };
        query.tab = val;
        if (val != this.settingTab) {
          this.$router.push({ query });
        }
      },
      get() {
        return this.$route.query.tab || "entity";
      },
    },
  },
};
</script>

<style scoped>
.setting-sidebar-wrapper {
  background-color: #fafafa;
  border-left: 1px solid #e2e8f0;
  border-right: 1px solid #e2e8f0;
}

.setting-sidebar-header {
  background: linear-gradient(135deg, #e0f7fa 0%, #ffffff 100%);
  border-bottom: 1px solid #e2e8f0;
}

.custom-setting-tab {
  margin: 4px 8px !important;
  border-radius: 8px !important;
  height: 42px !important;
  transition: all 0.2s ease-in-out !important;
  overflow: hidden;
}

.custom-setting-tab:hover {
  background-color: #f1f5f9 !important;
  overflow: hidden;
}

.custom-tab-active-item {
  background-color: #e0f7fa !important;
  color: #00838f !important;
  font-weight: 700 !important;
  border-left: 4px solid #00bcd4 !important;
  border-right: 4px solid #00bcd4 !important;
}
</style>
